import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CaseFile } from '../interface/CaseFile.interface';
import { EnvService } from 'src/app/services/env.service';
import { IUser } from 'src/app/core/interfaces/user.interface';
export interface IComment {
  _id?: string;
  archivo: string;
  contenido: string;
  usuario: IUser;
  date: Date;
  /** true si ya se pasó a los comentarios del caso. */
  enInforme?: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class CaseFileService {
  readonly baseUrl = `${this.env.URL_API_V1}/caseFile`;

  constructor(private readonly http: HttpClient, private env: EnvService) { }

  filterData = new Subject();

  createCaseFile(caseFile) {
    return this.http.post<CaseFile[]>(`${this.baseUrl}/create`, caseFile);
  }

  getAllCaseFile(id) {
    return this.http.get<CaseFile[]>(`${this.baseUrl}/byCase/${id}`);
  }

  deleteCaseFile(id) {
    return this.http.delete<CaseFile[]>(`${this.baseUrl}/delete/${id}`);
  }

  createComment(fileId: string, usuario: string, contenido: string) {
    return this.http.post(`${this.baseUrl}/comments/${fileId}`, { usuario, contenido, archivo: fileId });
  }

  getComments(fileId: string, pagina: number, limite: number): Observable<IComment[]> {
    return this.http.get<IComment[]>(`${this.baseUrl}/comments/${fileId}?pagina=${pagina}&limite=${limite}`);
  }

  deleteComment(commentId: string) {
    return this.http.delete(`${this.baseUrl}/comments/${commentId}`);
  }
}
